import { type DefaultRootState } from 'react-redux';

export default (id: number | 'create') => (state: DefaultRootState) => {
  if (id === 'create') {
    return 'library-fulltext';
  }
  return state.note.copilot.selectedContext || 'note';
};
